import { FC } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import { Row } from '../Layout';
import ButtonBase from '@mui/material/ButtonBase';
import Delete from '@mui/icons-material/Delete';
import CircularProgress from '@mui/material/CircularProgress';
import UploadFile from '@mui/icons-material/UploadFile';
import { SaveAlt } from '@mui/icons-material';

const FileListItemContainer = styled(Box)(({ theme }) => ({
  borderRadius: theme.shape.borderRadius,
  backgroundColor: theme.palette.grey[100],
  padding: theme.spacing(theme.spacingSizes.xs),
}));

const NameAndPreview = styled(Row)(() => ({
  overflow: 'hidden',
  flex: 1,
  minWidth: 0,
}));

const UploadingWrapper = styled(Row)(({ theme }) => ({
  marginLeft: theme.spacing(theme.spacingSizes.xs),
  flexShrink: 0,
}));

const DeleteButton = styled(ButtonBase)(({ theme }) => ({
  marginLeft: theme.spacing(theme.spacingSizes.xs),
  flexShrink: 0,
}));

const NameText = styled(Typography)(() => ({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
}));

type Props = {
  isUploading?: boolean;
  onDeleteFile?: () => void;
  downloadHref?: string;
  fileName: string;
  showDeleteButton?: boolean;
};

const FileListItem: FC<Props> = ({
  isUploading,
  onDeleteFile,
  fileName,
  downloadHref,
  showDeleteButton,
}) => {
  return (
    <FileListItemContainer>
      <Row centered justify="space-between" fullWidth>
        <NameAndPreview centered spacing="xs">
          <UploadFile fontSize="small" />
          <NameText variant="h6">{fileName}</NameText>
        </NameAndPreview>
        {downloadHref ? (
          <ButtonBase href={downloadHref}>
            <SaveAlt fontSize="small" />
          </ButtonBase>
        ) : null}
        {isUploading ? (
          <UploadingWrapper centered spacing="xs">
            <Typography variant="body2">Uploading... </Typography>
            <CircularProgress color="inherit" size={20} />
          </UploadingWrapper>
        ) : onDeleteFile && showDeleteButton ? (
          <DeleteButton
            onClick={() => {
              onDeleteFile();
            }}
          >
            <Delete fontSize="small" />
          </DeleteButton>
        ) : null}
      </Row>
    </FileListItemContainer>
  );
};

export default FileListItem;
